import { gql } from '@apollo/client'

export interface ILossPreventionItems {
  type: string
  amount: number
  count: number
  checkPercent: number
}

interface ICashControlDetails {
  [key: string]: {
    type: string
    amount: number
    count: number
    checkPercent: number | { value: number; color: string }
  }
}

export interface IListLocationLossPreventionKpisNodeType {
  locationInfo: {
    id: number
    code: string
    name: string
  }
  cashOverOrShort: number
  inaccurateCashierShiftPercent: number
  inaccurateCashierShiftCount: number
  lossPreventionItems: ILossPreventionItems[]
}

export interface IListLocationLossPreventionKpisType {
  listLocationLossPreventionKpis: {
    nodes: IListLocationLossPreventionKpisNodeType[]
  }
  listLocationMetricValues?: {
    nodes: {
      locationId: number
      metricData: null | Record<
        string,
        {
          code: string
          name: string
          unit: string
          value: number
        }
      >
    }[]
  }
}

export interface IListLocationGroupCashControlDetailsNodeType {
  locationGroupId: number
  locationGroupName: string
  startDate: string
  endDate: string
  cashControlDetails: ICashControlDetails
}

export interface IListLocationGroupCashControlDetailsType {
  listLocationGroupCashControlDetails: {
    nodes: IListLocationGroupCashControlDetailsNodeType[]
  }
  listLocationGroupMetricValues?: {
    nodes: {
      locationGroupId: number
      metricData: null | Record<
        string,
        {
          code: string
          name: string
          unit: string
          value: number
        }
      >
    }[]
  }
}

export const LIST_LOCATION_LOSS_PREVENTION_KPIS = gql`
  query ListLocationLossPreventionKpis(
    $iStartDate: Date!
    $iEndDate: Date!
    $iFilter: JSON!
    $useMetrics: Boolean!
  ) {
    listLocationLossPreventionKpis(
      iStartDate: $iStartDate
      iEndDate: $iEndDate
      iFilter: $iFilter
    ) {
      nodes {
        locationInfo {
          id
          code
          name
        }
        cashOverOrShort
        inaccurateCashierShiftCount
        inaccurateCashierShiftPercent
        lossPreventionItems
      }
    }

    listLocationMetricValues(
      iStartDate: $iStartDate
      iEndDate: $iEndDate
      iFilter: $iFilter
    ) @include(if: $useMetrics) {
      nodes {
        locationId
        metricData
      }
    }
  }
`

export const LIST_LOCATION_GROUP_CASH_CONTROL_DETAILS = gql`
  query ListLocationGroupCashControlDetails(
    $iStartDate: Date!
    $iEndDate: Date!
    $iFilter: JSON!
    $useMetrics: Boolean!
  ) {
    listLocationGroupCashControlDetails(
      iStartDate: $iStartDate
      iEndDate: $iEndDate
      iFilter: $iFilter
    ) {
      nodes {
        locationGroupId
        locationGroupName
        startDate
        endDate
        cashControlDetails
      }
    }

    listLocationGroupMetricValues(
      iStartDate: $iStartDate
      iEndDate: $iEndDate
      iFilter: $iFilter
    ) @include(if: $useMetrics) {
      nodes {
        locationGroupId
        metricData
      }
    }
  }
`

export const LIST_LOCATION_METRIC_VALUES = gql`
  query listLocationMetricValues(
    $iStartDate: Date!
    $iEndDate: Date!
    $iLocationGroupIds: [Int!]
    $iMetricCodes: [String!]!
  ) {
    listLocationMetricValues(
      iStartDate: $iStartDate
      iEndDate: $iEndDate
      iFilter: {
        location_group_ids: $iLocationGroupIds
        metrics: $iMetricCodes
      }
    ) {
      nodes {
        locationId
        metricData
        metricSummaryData
      }
    }
  }
`

export const LIST_LOCATION_GROUP_METRIC_VALUES = gql`
  query listLocationGroupMetricValues(
    $iStartDate: Date!
    $iEndDate: Date!
    $iLocationGroupTypes: [String!]
    $iMetricCodes: [String!]!
  ) {
    listLocationGroupMetricValues(
      iStartDate: $iStartDate
      iEndDate: $iEndDate
      iFilter: {
        location_group_types: $iLocationGroupTypes
        metrics: $iMetricCodes
      }
    ) {
      nodes {
        locationGroupId
        locationGroupName
        metricData
        metricSummaryData
      }
    }
  }
`
